import React from 'react'
import Dropdown, { DropdownOption } from '../common/Dropdown'
import { useTheme } from 'styled-components/native'

interface EditorDropdownProps {
  value: string
  placeholder: string
  options: DropdownOption[]
  disabled?: boolean
  onSelect: (value) => void
}

const EditorDropdown = ({
  options,
  value,
  onSelect,
  placeholder
}: EditorDropdownProps) => {
  const theme = useTheme()

  return (
    <Dropdown
      options={options}
      onSelect={onSelect}
      value={value}
      placeholder={placeholder}
      style={{
        backgroundColor: theme.colors.background,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    />
  )
}

export default EditorDropdown
